export const formatDateString = (dateString, isLocal = false) => {
  if (dateString) {
    const [datePart, timePart] = dateString.split(" ");
    const [day, month, year] = datePart.split("-");
    const isoDateString = `${year}-${month}-${day}T${timePart}`;
  
    const date = new Date(isoDateString);
  
    // Проверяем, является ли дата валидной
    if (isNaN(date)) {
      console.error("Invalid date:", dateString);
      return "";
    }
  
    // Применяем локальное смещение времени, если указано
    if (isLocal) {
      const offsetInMinutes = date.getTimezoneOffset();
      date.setMinutes(date.getMinutes() - offsetInMinutes);
    }
  
    const dayFormatted = String(date.getDate()).padStart(2, "0");
    const monthFormatted = String(date.getMonth() + 1).padStart(2, "0"); // месяцы начинаются с 0
    const yearFormatted = date.getFullYear();
  
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
  
    return `${dayFormatted}.${monthFormatted}.${yearFormatted} ${hours}:${minutes}`;
  } else {
    return "--.--.---- --:--"
  }
  
};
